import { Component, Input, EventEmitter, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../pages/base-error";

@Component({
  selector: "field-table",
  templateUrl: "./field-table.component.html",
})
export class FieldTableComponent extends BaseError {

  @Input() public item: any;
  @Output() public showDetails = new EventEmitter();
  public opened: boolean = true;

  constructor(
    public translate: TranslateService,
    public toastr: ToastrService,
  ) {
    super(toastr);
  }

  public handleDetail(event, e) {
    event.stopPropagation();
    // e.preventDefault();
    const data = {
      item: this.item,
      detail: e,
    };
    this.showDetails.emit(data);
  }

  public forwardDetails(e) {
    this.showDetails.emit(e);
  }

}
